import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import axios from './axios';
/**
 * 微信扫码展示接口
 */

export function getWechatPay(_x) {
  return _getWechatPay.apply(this, arguments);
}
/**
 * 支付宝扫码展示接口
 */

function _getWechatPay() {
  _getWechatPay = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", axios.post('/pay/order/pc/qrcode/wechat', data));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getWechatPay.apply(this, arguments);
}

export function getAlipayInfo(_x2) {
  return _getAlipayInfo.apply(this, arguments);
}
/**
 * 收银台结果页展示接口
 */

function _getAlipayInfo() {
  _getAlipayInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(data) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", axios.post('/pay/order/pc/qrcode/alipay', data));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getAlipayInfo.apply(this, arguments);
}

export function payResult(_x3) {
  return _payResult.apply(this, arguments);
}

function _payResult() {
  _payResult = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(data) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", axios.post('/pay/order/pc/qrcode/payresult', data));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _payResult.apply(this, arguments);
}